<template>
  <div class="home">
    <div class="container my-3 py-3 px-4">
      <div class="row">
        <div class="col-12">
          <h2 class="text-start mb-5">Notifications</h2>
        </div>
      </div>
      <div class="row mb-4 text-center"
          v-if="notifications.length === 0"
        >
          <div class="col-12 text-uppercase">
            No notifications available
          </div>
      </div>
      <div>
        <div
          v-for="notification in notifications"
          :key="notification.id"
          class="card mb-3"
        >
          <div class="card-header d-flex justify-content-between">
            {{ notification.title }}
            <div>
              <i v-show="notification.is_read" class="bi bi-check-circle-fill" />
              &nbsp;
              <i
                class="bi bi-trash cursor-pointer"
                @click="deleteNotification(notification.id)"
              />
            </div>
          </div>
          <div class="card-body">
            <blockquote class="blockquote mb-0">
              {{ notification.body }}
            </blockquote>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNotifications, deleteNotification } from '@/services/notifications/notification.api.js';

export default {
  name: 'ViewNotifications',
  data() {
    return {
      notifications: [],
    }
  },
  async mounted() {
    await this.getNotifications();
  },
  methods: {
    async getNotifications(){
      try {
        const {data} = await getNotifications();
        this.notifications = data.notifications.map(notification => ({
          id: notification.id,
          title: notification.title,
          body: notification.body,
          is_read: notification.notify_users.read
        }));
      } catch (error) {
        console.log(error)
      }
    },
    async deleteNotification(id) {
      try {
        await deleteNotification(id);
        this.notifications = this.notifications.filter(notification => notification.id !== id);
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>